module.exports = __webpack_public_path__ + "img/top-list-left5.e1274190.png";